(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-correction.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-correction.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect;
const getCorrectionMapHandler = svs.lyckoplatsen.components.shared_map.getCorrectionMapHandler;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const wagersAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.wagersAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  playCorrectionTlAtom = _svs$lyckoplatsen$com.playCorrectionTlAtom,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  correctionTriggerTypeAtom = _svs$lyckoplatsen$com.correctionTriggerTypeAtom,
  autoPlayLatestCorrectionTlAtom = _svs$lyckoplatsen$com.autoPlayLatestCorrectionTlAtom,
  distributionArrayAtom = _svs$lyckoplatsen$com.distributionArrayAtom;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.shared_constants.CONSTANTS,
  CORRECTION_STEP = _svs$lyckoplatsen$com2.CORRECTION_STEP,
  CORRECTION_TRIGGER_TYPE = _svs$lyckoplatsen$com2.CORRECTION_TRIGGER_TYPE;
const mapErrorDialogNoRedirect = svs.lyckoplatsen.shared_map.utils.mapErrorDialogNoRedirect;
const mapHandlerCorrection = getCorrectionMapHandler();
const MapCorrection = () => {
  const mapId = 'map-correction';
  const wagers = useAtomValue(wagersAtom);
  const result = useAtomValue(selectedResultAtom);
  const distributionArray = useAtomValue(distributionArrayAtom);
  const _useAtom = useAtom(correctionTriggerTypeAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    correctionTriggerType = _useAtom2[0],
    setCorrectionTriggerType = _useAtom2[1];
  const _useAtom3 = useAtom(playCorrectionTlAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    play = _useAtom4[0],
    setPlay = _useAtom4[1];
  const _useAtom5 = useAtom(autoPlayLatestCorrectionTlAtom),
    _useAtom6 = _slicedToArray(_useAtom5, 2),
    autoPlayLatest = _useAtom6[0],
    setAutoPlayLatest = _useAtom6[1];
  const _useAtom7 = useAtom(correctionStepAtom),
    _useAtom8 = _slicedToArray(_useAtom7, 2),
    correctionStep = _useAtom8[0],
    setCorrectionStep = _useAtom8[1];
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showMapErrorDialog = _React$useState2[0],
    setShowMapErrorDialog = _React$useState2[1];
  const mapErrorDialog = React.useCallback(() => {
    const step = productMapping.isLyckoplatsenPrimary(result.productId) ? 1 : 2;
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      icon: 'exclamation-sign',
      title: 'Karttjänsten ur funktion',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: svs.ui.dialog.message.align.CENTER,
        text: "Just nu g\xE5r det inte att visa kartan. Du kan visa r\xE4ttningen utan karta. Vill du se kartan f\xF6rs\xF6k igen om en stund"
      }],
      actions: [{
        title: 'Avbryt',
        callback(e, form, dialog) {
          dialog.close();
          setShowMapErrorDialog(false);
          if (correctionStep === CORRECTION_STEP.TOPWIN) {
            mapHandlerCorrection.tlSeek(1);
          }
          if (correctionStep >= CORRECTION_STEP.PLACE) {
            setCorrectionStep(step);
          }
        }
      }, {
        title: 'Fortsätt',
        callback(_e, _form, dialog) {
          dialog.close();
          setShowMapErrorDialog(false);
          setTimeout(() => {
            if (correctionStep <= CORRECTION_STEP.PLACE) {
              setPlay(true);
            } else {
              mapHandlerCorrection.tlPlay();
            }
          }, 1000);
        }
      }]
    }));
  }, [correctionStep, result.productId, setCorrectionStep, setPlay]);
  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      dragging: false,
      zoom: 15,
      zoomSnap: 0.2,
      zoomControl: false,
      scrollWheelZoom: false,
      geoJsonInv: false,
      showErrorOverlay: false,
      distributionArray,
      errorCallback: mapErrorDialogNoRedirect
    };
    const eventHandlers = {
      automatedStepUpdate: index => {
        setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.AUTOMATED);
        setCorrectionStep(index);
      },
      play: bool => {
        setPlay(bool);
      },
      showMapErrorDialog: () => setShowMapErrorDialog(true)
    };
    mapHandlerCorrection.createMap(mapOptions, result, wagers, eventHandlers);
    return () => {
      mapHandlerCorrection.removeMap();
      mapHandlerCorrection.tlKill();
      setPlay(false);
      setAutoPlayLatest(false);
    };
  }, [mapHandlerCorrection, mapId, result, setAutoPlayLatest, setCorrectionStep, setCorrectionTriggerType, setPlay]);

  useEffect(() => {
    if (showMapErrorDialog && play) {
      if (correctionStep <= CORRECTION_STEP.PLACE) {
        setPlay(false);
      } else {
        !play && mapHandlerCorrection.tlPause();
      }
      mapErrorDialog();
    }
  }, [showMapErrorDialog, play, setPlay, mapErrorDialog, correctionStep]);

  useEffect(() => {
    if (play) {
      mapHandlerCorrection.tlPlay();
    } else {
      mapHandlerCorrection.tlPause();
    }
  }, [play]);

  useEffect(() => {
    if (correctionTriggerType === CORRECTION_TRIGGER_TYPE.CLICK) {
      if (correctionStep >= CORRECTION_STEP.TOPWIN && correctionStep <= CORRECTION_STEP.DISTANCE) {
        mapHandlerCorrection.tlSeek(correctionStep);
      }
      setAutoPlayLatest(false);
    }
    if (correctionStep === CORRECTION_STEP.TOPWIN || correctionStep === CORRECTION_STEP.PLACE && productMapping.isLyckoplatsenSecondary(result.productId)) {
      setPlay(false);
    }
    if (correctionStep === CORRECTION_STEP.PLACE && productMapping.isLyckoplatsenPrimary(result.productId) || correctionStep === CORRECTION_STEP.DISTANCE) {
      setPlay(true);
      setAutoPlayLatest(false);
    }
    if (autoPlayLatest) {
      setPlay(true);
    }
  }, [correctionStep, setPlay, result.productId, correctionTriggerType, autoPlayLatest, setAutoPlayLatest]);
  return React.createElement("div", {
    id: mapId,
    className: "lp-map-correction"
  });
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapCorrection
});

 })(window);